import { Component, QueryList, ViewChildren } from '@angular/core';
import {DataService} from '../../../services/data/data.service';
import { CosechasService } from '../../../services/riesgo-credito/riesgos/cosechas.service';
import { CosechaClicService } from '../../../services/riesgo-credito/riesgos/cosecha-clic.service'
import {cosechaEntity, cosechaClickEntity } from './../entities_riesgos/entities_riesgos';
import { Aligment, ExcelService, FormatText } from '../../../services/excel/excel.service';
import * as d3 from 'd3-shape';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';
import { companiesRiesgoCredito } from '../../../shared/catalogos';
import { firstValueFrom } from 'rxjs';
import { messages } from '../../funciones/mensajes';
import { PeriodosService } from '../../../services/riesgo-credito/riesgos/periodos.service';
import { formatear } from '../../funciones/funcionesGenerales';
import moment from 'moment';
import { IMG } from '../../../services/imagen/png';
import { TextUtils } from '../../../components/pipes/text-utils';
import { FiltersM, typesApex } from '../../../components/models';
import { GraficadorComponent } from '../../../components/graficador/graficador.component';


@Component({
  selector: 'app-cosechas',
  templateUrl: './cosechas.component.html',
  styleUrl: './cosechas.component.css'
})
export class CosechasComponent {
  @ViewChildren(GraficadorComponent)grafCmp!:QueryList<GraficadorComponent>;
  public Filtros = FiltersM;

  // **** Cambio de miles a pesos ****
  miles1 = true;
  miles2 = true;
  milTab1 = '(Miles)';
  milTab2 = '(Miles)';
  //**** variables graficas ****
  tabla1 = true;
  barras1 = false;
  tabla2 = true;
  barras2 = false;
  // **** Modal ****
  tabla1Modal = false;
  barras1Modal = false;
  tabla2Modal = false;
  barras2Modal = false;
  tituloModal = '';
  // **** Datos graficas
  showLabels: boolean = true;
  showLabels2: boolean = true;
  xAxisLabel: string = 'Meses';
  yAxisLabel: string[] = ['Mora'];
  yAxisLabel2: string[] = ['Saldo'];
  dataMetodologia = [{nombre: "Grupal",prod: []},
                       {nombre: "Individual",prod: []}, 
                       {nombre: "Otros",prod: []}];
  public tipoGraf = typesApex.LINE;
  public changeLabel = true;
  public changeLabel2 = true;
  // **** Variables del web service ****
  cosechasclick = new cosechaClickEntity;
  cosecha = new cosechaEntity;
  cosecha2 = new cosechaEntity;
  periodo = 22022;
  // **** Variables de datos ****
  dataBarrasSald: any = [];
  dataBarrasMor: any = [];
  nombres_mes: any = [];
  nombres_mes2: any = [];
  nombres_mes3: any = [];
  // **** Variables del metodo de separacion de datos ****
  separador:string =  ","; // separador para los miles
  sepDecimal:string = '.'; // separador para los decimales
  // **** 
  public idInstitucion = 1002;
  public DatosAnios;
  public aniosDisponibles: any [];
  public mesesDisponibles: any [];
  public mesesDeAnioDisponibles: any[];
  public puedeFiltrarPorMeses = false;
  public subtituloGraficaTabla:string = "";
  public subtituloGrafica:string = "";
  public subtituloGraficaModal:string = "";
  public subtituloGrafica2:string = "";
  public etiquetas = [];
  public etiquetas2 = [];
  colorScheme : any = ['#6BAED6', '#A6D9C9', '#C5B0D5', '#F7B267', '#FEE191', '#BFD8B8', '#A8CBE8', '#F6A6A1', '#8FD8D2', '#7BAEBE' ];
  public mes = 'feb';
  public anio = '2022';
  perspectiva :boolean = false;
  dataSource: any [] = [];
  dataSource2: any [] = [];
  public dataCosechas: any [] = [];
  public subtituloCosechasClick = '';
  public titExp = '';
  /** Variable de porcentaje o de saldo */
  public tipoVista: string = 'Mora'; // Saldo  o  Mora  o  Colocacion
  public par: number = 30;
  private nombreFiltro;
  private nombreFiltro2;
    // VARIABLES PERSONALIZACION CATALAGO
  private bndInteres: boolean; // false -> sin intereses   true -> con intereses
  public submenus: number; 
  public smMoneda: String;  
  private parInclusive: number; // se incluye o excluye el numero par 
  public numPeriodos = [{name: 12, check: true},{name: 15, check: false},{name: 18, check: false},{name: 21, check: false},{name: 24, check: false}];
  public nPeriodosSel: number;
  public analisis = [{name: 'Periodo', check: true},{name: 'Maduración', check: false},];
  constructor(
    public dataService: DataService,
    private cosechaService: CosechasService,
    private cosechaclickService: CosechaClicService,
    private excelservices: ExcelService,
    private translate: TranslateService,
    private periodosService: PeriodosService,
    private cookies: CookieService
  ){
    formatear.momentAbrev();
    this.idInstitucion = Number(cookies.get('idInstitucion'))
    this.personalizacion();
    this.getPeriodos();
  }
  ngOnInit(): void {
  }
  public filterChange(filtro){
    this.nombreFiltro = '';
    switch (filtro.filtro){
      case 'zona': 
        this.nombreFiltro = filtro.elem.Nombre_Zona;
        this.cambioZon(filtro.elem);
        break;
      case 'sucursal':
        this.nombreFiltro = filtro.elem.Nombre_Sucursal;
        this.cambioSuc(filtro.elem);
        break;
      case 'producto': 
        this.nombreFiltro = filtro.elem.Nombre_Producto;
        this.cambioProd(filtro.elem);
        break;
      case 'sector':
        this.nombreFiltro = filtro.elem.Nombre_Sector;
        this.cambioSec(filtro.elem);
        break;
      case 'asesor':
        this.nombreFiltro = filtro.elem.Nombre_Asesor;
        this.cambioAsesor(filtro.elem);
        break;
    }
  }
  public filterChange2(filtro){
    this.nombreFiltro2 = '';
    switch (filtro.filtro){
      case 'zona': 
        this.nombreFiltro2 = filtro.elem.Nombre_Zona;
        this.cambioZon2(filtro.elem);
        break;
      case 'sucursal':
        this.nombreFiltro2 = filtro.elem.Nombre_Sucursal;
        this.cambioSuc2(filtro.elem);
        break;
      case 'producto': 
        this.nombreFiltro2 = filtro.elem.Nombre_Producto;
        this.cambioProd2(filtro.elem);
        break;
      case 'sector':
        this.nombreFiltro2 = filtro.elem.Nombre_Sector;
        this.cambioSec2(filtro.elem);
        break;
      case 'asesor':
        this.nombreFiltro2 = filtro.elem.Nombre_Asesor;
        this.cambioAsesor2(filtro.elem);
        break;
    }
  }
  private personalizacion(){
    var configInst = companiesRiesgoCredito.find(c => Number(c.id) === this.idInstitucion);
    this.bndInteres = configInst.interes;
    this.submenus = configInst.tipoMenu;
    this.smMoneda = configInst.moneda;
    this.parInclusive = configInst.parInclusive;
    this.nPeriodosSel = this.numPeriodos.find( i => i.check).name;
    for(let i=0; i < this.nPeriodosSel; i++){
      this.nombres_mes3.push('mes'+i);
    }
  }
  private async getPeriodos(){
    const info = await firstValueFrom(
      this.periodosService.getByAddUrl_Riesgo('informacionCargada', {InstitucionId: this.idInstitucion})
    );
    if(info.length > 0){
      this.DatosAnios = formatear.periodosRC(info);
      this.periodo = Number(this.DatosAnios.mesesDisponibles[this.DatosAnios.mesesDisponibles.length-1].value);
      this.mes = this.DatosAnios.mesesDisponibles[this.DatosAnios.mesesDisponibles.length-1].name;
      this.anio = this.DatosAnios.mesesDisponibles[this.DatosAnios.mesesDisponibles.length-1].year;
      this.DatosAnios.aniosDisponibles[this.DatosAnios.aniosDisponibles.length-1].check = true;
      this.FuncionesDataSource();
      this.FuncionesDataSource2();
      this.getDatos();
    }else{
      var nombre = companiesRiesgoCredito.find(c => Number(c.id) === this.idInstitucion).name;
      messages.infoMessageGraph(nombre + this.translate.instant('swal.instNoInfo'));
    }    
  }
  public FuncionesDataSource(){
    this.cosecha.InstitucionId = this.idInstitucion;
    this.cosecha.Periodo = this.periodo;
    this.cosecha.PAR = this.par;
    this.cosecha.BnPAR_Inclusive = this.parInclusive;
    this.cosecha.NPeriodosHst= this.nPeriodosSel;
    this.funcioncosechaSector(this.cosecha);
    this.maduracion();
  }
  public FuncionesDataSource2(){
    this.cosecha2.InstitucionId = this.idInstitucion;
    this.cosecha2.Periodo = this.periodo;
    this.cosecha2.PAR = this.par;
    this.cosecha2.BnPAR_Inclusive = this.parInclusive;
    this.cosecha2.NPeriodosHst= this.nPeriodosSel;
    this.funcioncosecha(this.cosecha2);
    this.maduracion();
  }
  public subtitulos(){
    this.subtituloGrafica = this.mes+' • '+this.anio.substring(2,4)+' | matriz | PAR ' + this.par+ ' | Sin intereses';
    
    if(this.cosecha.ZonaId != undefined){
      this.subtituloGrafica += '| Región '+ TextUtils.capitalize(this.nombreFiltro, 'words');
    }
    if(this.cosecha.ProductoId != undefined){
      if(this.submenus == 0){
        this.subtituloGrafica += '| Producto '+ TextUtils.capitalize(this.nombreFiltro, 'words');
      }else{
        this.subtituloGrafica += '| Producto '+ this.nombreFiltro
      }
    }
    if(this.cosecha.SectorId != undefined){
      this.subtituloGrafica += '| Sector '+ TextUtils.capitalize(this.nombreFiltro, 'words');
    }
    if(this.cosecha.SucursalId != undefined){
      this.subtituloGrafica += '| Oficina '+ TextUtils.capitalize(this.nombreFiltro, 'words');
    }
    if(this.cosecha.AsesorId != undefined){
      this.subtituloGrafica += '| Asesor '+ TextUtils.capitalize(this.nombreFiltro, 'words');
    }

    this.subtituloGrafica2 = this.mes+' • '+this.anio.substring(2,4)+' | matriz | PAR '+ this.par + ' | Sin intereses';
    if(this.cosecha2.ZonaId != undefined){
      this.subtituloGrafica2 += '| Región '+ TextUtils.capitalize(this.nombreFiltro2, 'words');
    }
    if(this.cosecha2.ProductoId != undefined){
      if(this.submenus == 0){
        this.subtituloGrafica2 += '| Producto '+ TextUtils.capitalize(this.nombreFiltro2, 'words');
      }else{
        this.subtituloGrafica2 += '| Producto '+ this.nombreFiltro2
      }      
    }
    if(this.cosecha2.SectorId != undefined){
      this.subtituloGrafica2 += '| Sector '+ TextUtils.capitalize(this.nombreFiltro2, 'words');
    }
    if(this.cosecha2.SucursalId != undefined){
      this.subtituloGrafica2 += '| Oficina '+ TextUtils.capitalize(this.nombreFiltro2, 'words');
    }
    if(this.cosecha2.AsesorId != undefined){
      this.subtituloGrafica2 += '| Asesor '+ TextUtils.capitalize(this.nombreFiltro2, 'words');
    }
  }
  getDatos(){
    this.aniosDisponibles = this.DatosAnios.aniosDisponibles;
    var aux = [];
    var pos;
    for(var i = 0; i < this.aniosDisponibles.length; i ++){
      if(this.aniosDisponibles[i].check == true){
        pos = i;
      }
    }
    for(var i =0; i < this.DatosAnios.mesesDisponibles.length; i++){
      if(this.DatosAnios.mesesDisponibles[i].year == this.aniosDisponibles[pos].name){
        aux.push(this.DatosAnios.mesesDisponibles[i]);
      }
    }
    this.mesesDisponibles=aux;
    this.mesesDisponibles[this.mesesDisponibles.length-1].check = true;
  }
  /** Obtención de datos */
  async funcioncosechaSector(cosechaEntity: any){
    try{
      const res = await firstValueFrom(this.cosechaService.getByAddUrl_Riesgo('cosechas',cosechaEntity));
      if(res.length === 0){
        messages.infoMessageGraph(this.translate.instant('swal.noInfoFiltro'));
      }else{
        this.Datos(res);
        this.subtitulos();
      }      
    }catch(err){
      messages.errorMessageGraph(err);
    }
  }
  async funcioncosecha(cosechaEntity: any){
    try{
      const res = await firstValueFrom(this.cosechaService.getByAddUrl_Riesgo('cosechas',cosechaEntity));
      if(res.length === 0){
        messages.infoMessageGraph(this.translate.instant('swal.noInfoFiltro'));
      }else{
        this.DatosT2(res);
        this.subtitulos();
      }   
    }catch(err){
      messages.errorMessageGraph(err);
    }
  }
  /** cambios en perspectivas */
  cambioSec(sec: any){
    this.cosecha.ZonaId = undefined;
    this.cosecha.ProductoId = undefined;
    this.cosecha.SectorId = sec.SectorId;
    this.cosecha.SucursalId = undefined;
    this.cosecha.AsesorId = undefined;
    this.FuncionesDataSource();
  }
  cambioSec2(sec: any){
    this.cosecha2.ZonaId = undefined;
    this.cosecha2.ProductoId = undefined;
    this.cosecha2.SectorId = sec.SectorId;
    this.cosecha2.SucursalId = undefined;
    this.cosecha2.AsesorId = undefined;
    this.FuncionesDataSource2();
  }
  cambioProd(prod: any){
    this.cosecha.ZonaId = undefined;
    this.cosecha.SectorId = undefined;
    this.cosecha.ProductoId = prod.ProductoId;
    this.cosecha.SucursalId = undefined;
    this.cosecha.AsesorId = undefined;
    this.FuncionesDataSource();
  }
  cambioProd2(prod: any){
    this.cosecha2.ZonaId = undefined;
    this.cosecha2.SectorId = undefined;
    this.cosecha2.ProductoId = prod.ProductoId;
    this.cosecha2.SucursalId = undefined;
    this.cosecha2.AsesorId = undefined;
    this.FuncionesDataSource2();
  }
  cambioZon(zon: any){
    this.cosecha.ProductoId = undefined;
    this.cosecha.SectorId = undefined;
    this.cosecha.ZonaId = zon.ZonaId;
    this.cosecha.SucursalId = undefined;
    this.cosecha.AsesorId = undefined;
    this.FuncionesDataSource();
  }
  cambioZon2(zon: any){
    this.cosecha2.ProductoId = undefined;
    this.cosecha2.SectorId = undefined;
    this.cosecha2.ZonaId = zon.ZonaId;
    this.cosecha2.SucursalId = undefined;
    this.cosecha2.AsesorId = undefined;
    this.FuncionesDataSource2();
  }
  cambioSuc(suc: any){
    this.cosecha.ProductoId = undefined;
    this.cosecha.SectorId = undefined;
    this.cosecha.ZonaId = undefined;
    this.cosecha.SucursalId = suc.SucursalId;
    this.cosecha.AsesorId = undefined;
    this.FuncionesDataSource();
  }
  cambioSuc2(suc: any){
    this.cosecha2.ProductoId = undefined;
    this.cosecha2.SectorId = undefined;
    this.cosecha2.ZonaId = undefined;
    this.cosecha2.SucursalId = suc.SucursalId;
    this.cosecha2.AsesorId = undefined;
    this.FuncionesDataSource2();
  }
  cambioAsesor(ase: any){
    this.cosecha.ProductoId = undefined;
    this.cosecha.SectorId = undefined;
    this.cosecha.ZonaId = undefined;
    this.cosecha.SucursalId = undefined;
    this.cosecha.AsesorId = ase.AsesorId;
    this.FuncionesDataSource();
  }
  cambioAsesor2(ase: any){
    this.cosecha2.ProductoId = undefined;
    this.cosecha2.SectorId = undefined;
    this.cosecha2.ZonaId = undefined;
    this.cosecha2.SucursalId = undefined;
    this.cosecha2.AsesorId = ase.AsesorId;
    this.FuncionesDataSource2();
  }
  /** formateo de datos */
  DatosT2(arreglo: any){
    var aux = [];
    for(var i =0; i <arreglo.length; i++){
      aux.push({periodo: arreglo[i].Periodo, cosecha: arreglo[i].FechaCosecha, colocacion: arreglo[i].ColocacionCosecha,
                saldo: arreglo[i].Saldo_Actual, mora: arreglo[i].Mora});
    }
    var j=0;
    var aux2 = [];
    for(var i =0; i <aux.length; i++){
      if( i>0){
        if(aux[i].cosecha == aux[(i-1)].cosecha){
          aux2[(j)].series.push( {periodo: arreglo[i].Periodo, colocacion: arreglo[i].ColocacionCosecha,
            saldo: arreglo[i].Saldo_Actual, mora: this.formatearmiles(arreglo[i].Saldo_Actual,this.miles2)} );
        }else{
          aux2.push({cosecha: aux[(i)].cosecha, series: [{periodo: arreglo[i].Periodo, colocacion: arreglo[i].ColocacionCosecha,
            saldo: arreglo[i].Saldo_Actual, mora: this.formatearmiles(arreglo[i].Saldo_Actual,this.miles2) }]});
          j++
        }
      }else{
        aux2.push({cosecha: aux[i].cosecha, series: [{periodo: arreglo[i].Periodo, colocacion: arreglo[i].ColocacionCosecha,
        saldo: arreglo[i].Saldo_Actual, mora: this.formatearmiles(arreglo[i].Saldo_Actual,this.miles2) }]});
      }
    }
    aux2.sort( (a,b) => moment(a.cosecha).valueOf() - moment(b.cosecha).valueOf() );
    for(const p of aux2){
      p.series.sort( (a,b) => a.periodo - b.periodo);
    }
    this.datosTablasaldo(aux2);
  }
  Datos(arreglo: any){
      var aux = [];
    switch(this.tipoVista){
      case 'Mora':
        for(var i =0; i <arreglo.length; i++){
          aux.push({periodo: arreglo[i].Periodo, cosecha: arreglo[i].FechaCosecha, colocacion: arreglo[i].ColocacionCosecha,
                    saldo: arreglo[i].Saldo_Actual, mora: arreglo[i].MorosidadSaldo*100});
        }
        break;
      case 'Colocacion':
        for(var i =0; i <arreglo.length; i++){
          aux.push({periodo: arreglo[i].Periodo, cosecha: arreglo[i].FechaCosecha, colocacion: arreglo[i].ColocacionCosecha,
                    saldo: arreglo[i].Saldo_Actual, mora: arreglo[i].MorosidadColocado*100});
        }
        break;
      default:
        for(var i =0; i <arreglo.length; i++){
          aux.push({periodo: arreglo[i].Periodo, cosecha: arreglo[i].FechaCosecha, colocacion: arreglo[i].ColocacionCosecha,
                    saldo: arreglo[i].Saldo_Actual, mora: arreglo[i].Mora});
        }        
        break;
    }
    var j=0;
    var aux2 = [];
    switch(this.tipoVista){
      case 'Colocacion':
        for(var i =0; i <aux.length; i++){
          if( i>0){
            if(aux[i].cosecha == aux[(i-1)].cosecha){
              aux2[(j)].series.push( {periodo: arreglo[i].Periodo, colocacion: arreglo[i].ColocacionCosecha,
                saldo: arreglo[i].Saldo_Actual, mora: Number((arreglo[i].MorosidadColocado*100).toFixed(2))} );
            }else{
              aux2.push({cosecha: aux[(i)].cosecha, series: [{periodo: arreglo[i].Periodo, colocacion: arreglo[i].ColocacionCosecha,
                saldo: arreglo[i].Saldo_Actual, mora: Number((arreglo[i].MorosidadColocado*100).toFixed(2)) }]});
              j++
            }
          }else{
            aux2.push({cosecha: aux[i].cosecha, series: [{periodo: arreglo[i].Periodo, colocacion: arreglo[i].ColocacionCosecha,
              saldo: arreglo[i].Saldo_Actual, mora: Number((arreglo[i].MorosidadColocado*100).toFixed(2)) }]});
          }
        }
        break;
      case 'Mora':
        for(var i =0; i <aux.length; i++){
          if( i>0){
            if(aux[i].cosecha == aux[(i-1)].cosecha){
              aux2[(j)].series.push( {periodo: arreglo[i].Periodo, colocacion: arreglo[i].ColocacionCosecha,
                saldo: arreglo[i].Saldo_Actual, mora: Number((arreglo[i].MorosidadSaldo*100).toFixed(2))} );
            }else{
              aux2.push({cosecha: aux[(i)].cosecha, series: [{periodo: arreglo[i].Periodo, colocacion: arreglo[i].ColocacionCosecha,
                saldo: arreglo[i].Saldo_Actual, mora: Number((arreglo[i].MorosidadSaldo*100).toFixed(2)) }]});
              j++
            }
          }else{
            aux2.push({cosecha: aux[i].cosecha, series: [{periodo: arreglo[i].Periodo, colocacion: arreglo[i].ColocacionCosecha,
              saldo: arreglo[i].Saldo_Actual, mora: Number((arreglo[i].MorosidadSaldo*100).toFixed(2)) }]});
          }
        }
        break;
      default:
        for(var i =0; i <aux.length; i++){
          if( i>0){
            if(aux[i].cosecha == aux[(i-1)].cosecha){
              aux2[(j)].series.push( {periodo: arreglo[i].Periodo, colocacion: arreglo[i].ColocacionCosecha,
                saldo: arreglo[i].Saldo_Actual, mora: this.formatearmiles(arreglo[i].Mora,this.miles1)} );
            }else{
              aux2.push({cosecha: aux[(i)].cosecha, series: [{periodo: arreglo[i].Periodo, colocacion: arreglo[i].ColocacionCosecha,
                saldo: arreglo[i].Saldo_Actual, mora: this.formatearmiles(arreglo[i].Mora,this.miles1) }]});
              j++
            }
          }else{
            aux2.push({cosecha: aux[i].cosecha, series: [{periodo: arreglo[i].Periodo, colocacion: arreglo[i].ColocacionCosecha,
              saldo: arreglo[i].Saldo_Actual, mora: this.formatearmiles(arreglo[i].Mora,this.miles1) }]});
          }
        }
        break;

    }    
    aux2.sort( (a,b) => moment(a.cosecha).valueOf() - moment(b.cosecha).valueOf() );
    for(const p of aux2){
      p.series.sort( (a,b) => a.periodo - b.periodo);
    }
    this.datosTablacosecha(aux2);
  }
  graficas_lineales(){
    var auxFinal = [];
    const info = [...this.dataSource];
    info.reverse();
    const periodos = [ ...new Set(info.map( item => item.cosecha)) ];
    info.forEach( per => {
      const data = per.meses.filter(d => d !== '');
      auxFinal.push({
        name: per.cosecha,
        data: data
      });
    });
    this.dataBarrasMor = auxFinal;
    this.etiquetas = periodos;
  }
  graficas_linealesSal(){
    var auxFinal = [];
    const info = [...this.dataSource2];
    info.reverse();
    const periodos = [ ...new Set(info.map( item => item.cosecha)) ];
    info.forEach( per => {
      const dat = info.filter( i => i.cosecha === per);
      dat.sort( (a,b) => b.periodo-a.periodo)
      const data = per.meses.filter(i => i != null && i.trim() !== '')
                .map(i => Number(i.replace(/,/g, '').trim()))
                .filter(n => !isNaN(n));
      auxFinal.push({
        name: per.cosecha,
        data: data
      });
    });
    this.dataBarrasSald = auxFinal;
    this.etiquetas2 = periodos;
  }
  /** Cambio de graficas */
  Graficas1(letra: any){
    if('T' == letra){
      this.tabla1 = true;
      this.barras1 = false;
    }
    if('L' == letra){
      this.tabla1 = false;
      this.barras1 = true;
    }
  }
  Graficas2(letra: any){
    if('T' == letra){
      this.tabla2 = true;
      this.barras2 = false;
    }
    if('L' == letra){
      this.tabla2 = false;
      this.barras2 = true;
    }
  }
  /** formato de las tablas */
  datosTablacosecha(arreglo: any){
    var aux = [];
    this.nombres_mes = [];
    if(arreglo.length != 0){
      for(var i=0; i<arreglo[0].series.length; i++){
        this.nombres_mes.push(moment(arreglo[0].series[i].periodo, 'YYYYMM').format('MMM YY').toLocaleLowerCase());
      }
      this.nombres_mes.reverse();
      for(var i =0; i <arreglo.length; i++){
        var meses = [];
        for(let m = 1; m <= this.nombres_mes.length; m++){
          meses.push(this.asignacion(i,m,arreglo))
        }
        aux.push({cosecha: moment(arreglo[i].cosecha).format('MMM YY').toLocaleLowerCase(), montocolocado: this.formatearmiles(arreglo[i].series[0].colocacion,this.miles1),
          meses: meses
        });
      }
    }  
    this.dataSource = aux;
    this.maduracion();
    this.graficas_lineales();
  }
  datosTablasaldo(arreglo: any){
    var aux = [];
    this.nombres_mes2 = []
    if(arreglo.length != 0){
      for(var i=0; i<arreglo[0].series.length; i++){
        this.nombres_mes2.push(moment(arreglo[0].series[i].periodo, 'YYYYMM').format('MMM YY').toLocaleLowerCase());
      }
      for(var i =0; i <arreglo.length; i++){
        var meses = [];
        for(let m = 1; m <= this.nombres_mes2.length; m++){
          meses.push(this.asignacion(i,m,arreglo));
        }
        aux.push({cosecha: moment(arreglo[i].cosecha,'YYYY-MM-DD').format('MMM YY').toLocaleLowerCase(), montocolocado: this.formatearmiles(arreglo[i].series[0].colocacion,this.miles2),
          meses: meses
        });
      }
    }   
    this.dataSource2 = aux;
    this.maduracion();
    this.graficas_linealesSal();
  }
  /** exportación */
  export_csv(tab: any){
    var aux = [];
    var data_excel = [];
    var name = '';
    var encabezado_excel = ['Cosecha','Monto colocado'];
    for(let i = 0;i < this.nombres_mes.length; i++){
      this.analisis[0].check ? encabezado_excel.push(this.nombres_mes[i]) : encabezado_excel.push('mes '+i);
    }
    //this.desForm(this.dataSource[0].mes2)
    if(tab == 1){
      var cadena_evaluacion = this.nombres_mes;
      if(this.tipoVista === 'Saldo'){
        for(var i = 0; i < this.dataSource.length; i++ ){
          aux.push(this.dataSource[i].cosecha)
          aux.push(this.desForm(this.dataSource[i].montocolocado))
          var cont = 2
          for(const j of this.dataSource[i].meses){
            if(encabezado_excel[cont] !== undefined) aux.push(this.desForm(j));
            cont++;
          }
          data_excel.push(aux);
          aux = [];
        }
        name = 'Saldo por mora';
      }else{
        for(var i = 0; i < this.dataSource.length; i++ ){
          aux.push(this.dataSource[i].cosecha)
          aux.push(this.desForm(this.dataSource[i].montocolocado))
          var cont = 2;
          for(const j of this.dataSource[i].meses){
            if(encabezado_excel[cont] !== undefined) aux.push(Number((j/100).toFixed(4)));
            cont++;
          }
          data_excel.push(aux);
          aux = [];
        }
        name = 'Porcentaje por mora';
      }
    }else{
      var cadena_evaluacion = this.nombres_mes
      for(var i = 0; i < this.dataSource.length; i++ ){
        aux.push(this.dataSource2[i].cosecha)
        aux.push(this.desForm(this.dataSource2[i].montocolocado));
        var cont = 2;
        for(const j of this.dataSource2[i].meses){
          if(encabezado_excel[cont] !== undefined)aux.push(this.desForm(j));
          cont ++
        }
        data_excel.push(aux);
        aux = [];
      }
      name = 'Saldo total';
    }

    let nombreArch = ""
    let nombre = "";
    if(!this.tabla1 && this.tipoVista === 'Saldo' && (name == 'Porcentaje por mora' || name == 'Saldo por mora')){
      nombreArch = "Saldo por mora"
      nombre = "Saldo por mora  " + this.subtituloGrafica
    }
    if(!this.tabla1 && this.tipoVista === 'Mora' && (name == 'Porcentaje por mora' || name == 'Saldo por mora')){
      nombreArch = "Porcentaje por mora"
      nombre= "Porcentaje por mora  " + this.subtituloGrafica
    }
    if(this.tabla1 && this.tipoVista === 'Saldo' && (name == 'Porcentaje por mora' || name == 'Saldo por mora')){
      nombreArch = "Saldo por mora miles"
      nombre = this.milTab1 + " Saldo por mora  " + this.subtituloGrafica
    }
    if(this.tabla1 && this.tipoVista === 'Mora' && (name == 'Porcentaje por mora' || name == 'Saldo por mora')){
      nombreArch = "Porcentaje por mora"
      nombre = "Porcentaje por mora  " + this.subtituloGrafica
    }
    if(!this.tabla2 && name == 'Saldo total'){
      nombreArch = "Saldo total";
      nombre = "Saldo total | " + this.subtituloGrafica2
    }
    if(this.tabla2 && name == 'Saldo total'){
      nombreArch = "Saldo total miles";
      nombre = this.milTab2 + "Saldo total | " + this.subtituloGrafica2 
    }
    nombreArch += ` ${this.mes}-${this.anio.substring(2,4)}` 
    let titHoja = this.translate.instant('menu.'+this.dataService.moduleSelect) + " • " + nombre ;
    this.excelservices.generateExcelCosecha(titHoja,encabezado_excel,data_excel,cadena_evaluacion.length,name,this.tipoVista !== 'Saldo',nombreArch);
  }
  export_img(id: any){
    var nombre = {titulo: '', subtitulo:'', nombreArch:''};
    if(id == 1){
      nombre.titulo = `${this.translate.instant('riesgo-credito.cosechas.tit'+this.tipoVista)} ${this.milTab1}`;
      nombre.nombreArch = `${this.translate.instant('riesgo-credito.cosechas.tit'+this.tipoVista)} ${this.milTab1}`;

      nombre.subtitulo = this.subtituloGrafica;
    }else{
      nombre.titulo = `${this.translate.instant('riesgo-credito.cosechas.enc2')}`;
      nombre.subtitulo = this.subtituloGrafica2;
      nombre.nombreArch = `${this.translate.instant('riesgo-credito.cosechas.enc2')}`;
    }
    const comp = this.grafCmp.find(g => g.zona === id);
    comp.exportImg(id,nombre)
  }
  /** Pintado de la tabla */
  pintar(pos: any, col: any){    
    if(pos == col)
      return "w3-grey-per ";
    if(pos > col)
      return "w3-light-grey ";
    else
      return '';
  }
  colorText(num){
    var aux='';
    if(this.tipoVista !== 'Saldo' && num != undefined){
      if(num > 0 && num <= 5)
        return ''//'#5AB436'//'#72D54A'
      else if(num > 5 && num <= 10)
        return ''//'#F2C806'//'#FFD100'
      else if( num > 10)
        return '#FF495C'//'#FF495C' '#CF1A2D'
      else
        return '';
    }else
      return '';
  }
  pintarPorcent(num){
    var aux = ''+num;
    if(aux != '')
      return true;
    return false;
  }
  asignacion(i: any, nm: any, arreglo: any){
    if((arreglo[i].series.length-nm)>=0){
      return arreglo[i].series[arreglo[i].series.length-nm].mora;
    }
    else{
      return '';
    }
  }
  // **** Función de formateo de numeros ****
  formatearnormal(num: any){
    num +='';
    var splitStr = num.split('.');
    var splitLeft = splitStr[0];
    var splitRight = splitStr.length > 1 ? this.sepDecimal + splitStr[1] : '';
    var regx = /(\d+)(\d{3})/;
    while (regx.test(splitLeft)) {
    splitLeft = splitLeft.replace(regx, '$1' + this.separador + '$2');
    }
    return  splitLeft;
  }
  formatearmiles(num: any, miles: any){
    if(miles == true)
      num = (num/1000).toFixed(3)
    num +='';
    var splitStr = num.split('.');
    var splitLeft = splitStr[0];
    var splitRight = splitStr.length > 1 ? this.sepDecimal + splitStr[1] : '';
    var regx = /(\d+)(\d{3})/;
    while (regx.test(splitLeft)) {
    splitLeft = splitLeft.replace(regx, '$1' + this.separador + '$2');
    }
    return  splitLeft;
  }
  desForm(num: any){
    if(num.includes(',')){  
      var pos = num.indexOf(',');
      var aux = num.slice(0,pos)+num.slice(pos+1);
      num = aux;
      while(num.includes(',')){
        var pos = num.indexOf(',');
        var aux = num.slice(0,pos)+num.slice(pos+1);
        num = aux;
      }
    }
    if(num == '')
      return num;
    num = Number(num);
    return num;
  }
  CambMon( moneda: any, tab: any ){
    if(moneda == 'Mil' && tab == 1){
      this.miles1 = true;
      this.milTab1 = '(Miles)';
      this.FuncionesDataSource();
    }
    if(moneda == 'Mil' && tab == 2){
      this.miles2 = true;
      this.milTab2 = '(Miles)';
      this.FuncionesDataSource2();
    }
    if(moneda == 'Pesos' && tab == 1 ){
      this.miles1 = false;
      this.milTab1 = '';
      this.FuncionesDataSource();
    }
    if(moneda == 'Pesos' && tab == 2 ){
      this.miles2 = false;
      this.milTab2 = '';
      this.FuncionesDataSource2();      
    }
  }
  /** Cambio de porcentaje a saldo de la primer grafica */
  public MostrarPor(tipo){
    this.tipoVista = tipo;
    this.funcioncosechaSector(this.cosecha);
  }
  /* funciones para los filtros */
  public anioChange(anio: any){
    var pos = 0;
    for(var i =0; i < this.aniosDisponibles.length; i++){
      this.aniosDisponibles[i].check = false;
    }
    for(var i =0; i < this.aniosDisponibles.length; i++){
      if(this.aniosDisponibles[i].value == anio.value){
        this.aniosDisponibles[i].check = true;
        pos = i;
      }
    }
    for(var i = 0; i < this.mesesDisponibles.length; i++ ){
      this.mesesDisponibles[i].check = false
    }
    var aux = [];
    for(var i =0; i < this.DatosAnios.mesesDisponibles.length; i++){
      if(this.DatosAnios.mesesDisponibles[i].year == this.aniosDisponibles[pos].name){
        aux.push(this.DatosAnios.mesesDisponibles[i])
      }
    }
    this.mesesDisponibles=aux;
    this.mesesDisponibles[this.mesesDisponibles.length-1].check = true;
    this.mes = this.mesesDisponibles[this.mesesDisponibles.length-1].name;
    this.anio = this.aniosDisponibles[pos].name;
    this.periodo = Number(this.mesesDisponibles[this.mesesDisponibles.length-1].value);
    this.FuncionesDataSource();
    this.FuncionesDataSource2();
  }
  public mesChange(mes: any){
    for(var i = 0; i < this.mesesDisponibles.length; i++ ){
      this.mesesDisponibles[i].check = false
    }
    var pos =0;
    for(var i = 0; i < this.mesesDisponibles.length; i++ ){
      if(this.mesesDisponibles[i].name == mes.name){
        this.mesesDisponibles[i].check = true;
        pos = i;
      }
    }
    this.mes = this.mesesDisponibles[pos].name;
    this.periodo = Number(this.mesesDisponibles[pos].value);
    this.FuncionesDataSource();
    this.FuncionesDataSource2();
  }
  ampliar(amp: any){
    if(amp == 'tabla1'){
      this.tituloModal = `${this.translate.instant('riesgo-credito.cosechas.tit'+this.tipoVista)} ${this.milTab1}`;
      this.subtituloGraficaTabla = this.subtituloGrafica;
      this.subtituloGraficaModal = this.subtituloGrafica;
      if(this.tabla1){
        this.tabla1Modal = true;
        this.barras1Modal = false;
        this.tabla2Modal = false;
        this.barras2Modal = false;
      }
      if(this.barras1){
        this.tabla1Modal = false;
        this.barras1Modal = true;
        this.tabla2Modal = false;
        this.barras2Modal = false;
      }
    }
    if(amp == 'tabla2'){
      this.tituloModal = `${this.translate.instant('riesgo-credito.cosechas.enc2')} `;
      this.subtituloGraficaTabla = this.subtituloGrafica2;
      this.subtituloGraficaModal = this.subtituloGrafica2;
      if(this.tabla2){
        this.tituloModal += this.milTab2;
        this.tabla1Modal = false;
        this.barras1Modal = false;
        this.tabla2Modal = true;
        this.barras2Modal = false;
      }
      if(this.barras2){
        this.tabla1Modal = false;
        this.barras1Modal = false;
        this.tabla2Modal = false;
        this.barras2Modal = true;
      }
    }
    document.getElementById('graficasModal').style.display='block'
  }
  cerrarAmp(){
    this.tabla1Modal = false;
    this.barras1Modal = false;
    this.tabla2Modal = false;
    this.barras2Modal = false;
  }
  public quitarFiltros(): void {
    this.tipoVista = 'Mora'
    for(var i =0; i < this.aniosDisponibles.length; i++){
      this.aniosDisponibles[i].check = false;
    }
    this.aniosDisponibles[this.aniosDisponibles.length-1].check = true;
    for(var i = 0; i < this.mesesDisponibles.length; i++ ){
      this.mesesDisponibles[i].check = false
    }
    var aux = [];
    for(var i =0; i < this.DatosAnios.mesesDisponibles.length; i++){
      if(this.DatosAnios.mesesDisponibles[i].year == this.aniosDisponibles[this.aniosDisponibles.length-1].name){
        aux.push(this.DatosAnios.mesesDisponibles[i])
      }
    }
    this.mesesDisponibles=aux;
    this.mesesDisponibles[this.mesesDisponibles.length-1].check = true;
    this.mes = this.mesesDisponibles[this.mesesDisponibles.length-1].name;
    this.anio = this.aniosDisponibles[this.aniosDisponibles.length-1].name;
    this.periodo = Number(this.mesesDisponibles[this.mesesDisponibles.length-1].value);
    this.tabla1 = true;
    this.barras1 = false;
    this.tabla2 = true;
    this.barras2 = false;
    this.cosecha.ZonaId = undefined;
    this.cosecha.ProductoId = undefined;
    this.cosecha.SectorId = undefined;
    this.cosecha.SucursalId = undefined;
    this.cosecha2.ZonaId = undefined;
    this.cosecha2.ProductoId = undefined;
    this.cosecha2.SectorId = undefined;
    this.cosecha2.SucursalId = undefined;
    this.miles1 = true;
    this.milTab1 = '(Miles)';
    this.miles2 = true;
    this.milTab2 = '(Miles)';
    this.par = 30;
    this.showLabels = true;
    this.showLabels2 = true;    
    this.numPeriodos = [{name: 12, check: true},{name: 15, check: false},{name: 18, check: false},{name: 21, check: false},{name: 24, check: false}];
    this.nPeriodosSel = 12;
    this.analisis = [{name: 'Periodo', check: true},{name: 'Maduración', check: false},];
    this.FuncionesDataSource();
    this.FuncionesDataSource2();
  }
  /** eventos de la tabla */
  public async clickTab(dat, cos, tabla){
    this.dataCosechas = [];
    var per1, per2;
    per1 = moment(dat, 'MMM YY').format('YYYYMM');
    per2 = moment(cos, 'MMM YY').format('YYYYMM');
    this.cosechasclick.InstitucionId = this.idInstitucion;
    this.cosechasclick.Periodo = per1;
    this.cosechasclick.PeriodoCosecha = per2;
    this.cosechasclick.PAR = this.par;
    this.cosechasclick.BnPAR_Inclusive = this.parInclusive;
    // this.cosechasclick.BnConIntereses = this.bndInteres;
    var aux = [];
    try{
      const res = await firstValueFrom(this.cosechaclickService.getByAddUrl_Riesgo('cosechas/listado-registros',this.cosechasclick));
      aux = this.dataclick(res);
      aux = tabla === 1 ? aux.filter(e => e.dMor > this.par) : aux;
      var suma = aux.reduce(
        (acc, i) => acc + (i.sal ?? 0), 0
      );
      aux.push({
        nCred: 'Totales',
        cSocio: aux.length,
        nom: '',
        dMor: '',
        prod: '',
        sal: suma,
        estatus: ''
      });
      this.dataCosechas = aux;
      this.subtituloCosechasClick = 'Cosecha de: ' + dat + ' | Saldos a: ' + cos + ' | PAR 30 | Sin intereses';
      this.titExp = 'Cosecha de: ' + dat + ' saldos a: ' + cos;
      document.getElementById('modalTabla').style.display='block';
    }catch(err){
      messages.errorMessageGraph(err);
    }
  }
  public dataclick(response){
    var aux = [];
    for(const data of response){
      aux.push({
        nCred: data.CreditoId,
        cSocio: data.Clave_Socio,
        nom: data.Nombre_Socio,
        dMor: data.Dias_Mora,
        prod: data.Nombre_Producto,
        sal: data.Saldo_Actual,
        sucursal: data.Nombre_Sucursal,
        tipo: data.Nombre_TipoCredito,
        // TODO Revisar a que corresponde lo del estatus credito
        estatus: ''//data.Nombre_EstatusCredito.split('-')[1]
      });
    }
    var suma = 0;
    for(const data of aux){
      suma += data.sal;
    }
    return aux;
  } 
  public exportar_cscClick(){
    var aux = [];
    var data_excel = [];
    var encabezado_excel = [
      this.translate.instant('riesgo-credito.cosechas.tit5'),
      this.translate.instant('riesgo-credito.cosechas.tit6'),
      this.translate.instant('riesgo-credito.cosechas.tit7'),
      this.translate.instant('riesgo-credito.cosechas.tit8'),
      this.translate.instant('riesgo-credito.cosechas.tit12'),
      this.translate.instant('riesgo-credito.cosechas.tit9'),
      this.translate.instant('riesgo-credito.cosechas.tit10'),
      this.translate.instant('riesgo-credito.cosechas.tit13'),
      // this.translate.instant('riesgo-credito.cosechas.tit11'),
    ];
    var alineacion = [Aligment.RIGHT,Aligment.RIGHT,Aligment.CENTER,Aligment.CENTER,Aligment.CENTER,Aligment.CENTER,Aligment.RIGHT,Aligment.CENTER,Aligment.CENTER];
    var formato = [FormatText.TEXT,FormatText.NUMBER,FormatText.TEXT,FormatText.NUMBER,FormatText.TEXT,FormatText.TEXT,FormatText.NUMBER,FormatText.TEXT,FormatText.TEXT]
    var tit = `${this.translate.instant('riesgo-credito.cosechas.enc3')} • ${this.subtituloCosechasClick}`;
    var nombreArch = this.translate.instant('riesgo-credito.cosechas.enc3');
    for(const ins of this.dataCosechas){
      aux.push(ins.nCred);
      aux.push(Number(ins.cSocio));
      aux.push(ins.nom);
      aux.push(ins.dMor);
      aux.push(ins.sucursal);
      aux.push(ins.prod);
      aux.push(ins.sal);
      aux.push(ins.tipo);
      // aux.push(ins.estatus);
      data_excel.push(aux);
      aux = [];
    }
    this.excelservices.generateExcel(tit,encabezado_excel,data_excel,nombreArch,alineacion,formato);
  }
  public cambiarPar(par){
    this.par = par;
    this.FuncionesDataSource()
    this.FuncionesDataSource2()
  }
  public cambioAnalisis(sel){
    for(const pers of this.analisis){
      if(sel.name === pers.name){
        pers.check = !pers.check;
      }else{
        pers.check = false;
      }
    }

    switch(sel.name){
      case 'Periodo':
        this.periodoBase()
      break;
      case 'Maduración':
        this.maduracion();
      break;
    }
  }
  public cambioNumPeriodo(sel){
    for(const pers of this.numPeriodos){
      if(sel.name === pers.name){
        pers.check = !pers.check;
      }else{
        pers.check = false;
      }
    }
    this.nPeriodosSel = this.numPeriodos.find( i => i.check).name;
    this.FuncionesDataSource();
    this.FuncionesDataSource2();
  }
  private maduracion(){
    if(this.analisis[1].check){
      var aux = structuredClone(this.dataSource);
      var aux2 = structuredClone(this.dataSource2);
      for(const d of aux){
        d.meses.sort((a,b) => {
          if(a === "" && b !== "") return -1;
          if(a !== "" && b === "") return 1;
          return 0;
        });
        d.meses.reverse();
      }
      this.dataSource = aux;
      for(const d of aux2){
        d.meses.sort((a,b) => {
          if(a === "" && b !== "") return -1;
          if(a !== "" && b === "") return 1;
          return 0;
        });
        d.meses.reverse();
      }
      this.dataSource2 = aux2;
    }
    this.graficas_lineales();
    this.graficas_linealesSal();
  }
  private periodoBase(){
    if(this.analisis[0].check){
      var aux = structuredClone(this.dataSource);
      var aux2 = structuredClone(this.dataSource2);
      for(const d of aux){
        d.meses.reverse();
        d.meses.sort((a,b) => {
          if(a === "" && b !== "") return 1;
          if(a !== "" && b === "") return -1;
          return 0;
        });
        
      }
      this.dataSource = aux;
      for(const d of aux2){
        d.meses.reverse();
        d.meses.sort((a,b) => {
          if(a === "" && b !== "") return 1;
          if(a !== "" && b === "") return -1;
          return 0;
        })        
      }
      this.dataSource2 = aux2;
    }
  }
}

